import { render } from "./productPage.vue?vue&type=template&id=22914c20&scoped=true"
import script from "./productPage.vue?vue&type=script&lang=js"
export * from "./productPage.vue?vue&type=script&lang=js"

import "./productPage.vue?vue&type=style&index=0&id=22914c20&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22914c20"]])

export default __exports__